module.exports = ".align-buttons {\n  text-align: right; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/master/master-register-platforms/master-register-platforms.component.scss
// module id = ./src/app/master/master-register-platforms/master-register-platforms.component.scss
// module chunks = main